import { Skeleton } from 'antd'
import { Row } from './styled'

export const TableSkeleton = () => {
  return (
    <div>
      <Row marginbottom="15">
        <Skeleton paragraph={{ rows: 0 }} title={{ width: '100%' }} active />
      </Row>
      <Row marginbottom="15">
        <Skeleton paragraph={{ rows: 0 }} title={{ width: '100%' }} active />
      </Row>
      <Row marginbottom="0">
        <Skeleton paragraph={{ rows: 0 }} title={{ width: '100%' }} active />
      </Row>
    </div>
  )
}
